export default __webpack_public_path__ + "static/media/brickfloor3.70c7f681.png";